let Storage = {
    Components: {
        Spinner: null,
        StatusBar: null,
    },
};
  
module.exports = Storage;
  